import styled, { css } from 'styled-components';
import { rem } from 'polished';

import Icon from '../Icon';

const StyledDropdown = styled.div`
  font-family: ${props => props.theme.fonts.book};
  position: relative;
  width: 100%;
  ${props =>
    props.small &&
    css`
      max-width: ${props.modalActive !== true && rem('270px')};
    `};
`;

const StyledSpan = styled.span`
  display: inline-block;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 90%;
`;

const StyledUl = styled.ul`
  border: 0.0625rem solid ${props => props.theme.colors.secondary};
  border-top: 0;
  display: none;
  margin: 0;
  max-height: ${rem('190px')};
  overflow-y: auto;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 3;

  ${props =>
    props.expanded &&
    css`
      display: block;
    `};
`;

const StyledLi = styled.li`
  padding-left: 0;
  :before {
    content: none;
  }
`;

const StyledLink = styled.a`
  background: ${props => props.theme.colors.light};
  clear: both;
  color: ${props => props.theme.colors.grayDarkest};
  display: block;
  font-size: ${rem('14px')};
  padding: ${rem('7px')} ${rem('10px')};
  text-align: left;

  &:hover {
    background: ${props => props.theme.colors.grayLight};
    font-family: ${props => props.theme.fonts.medium};
  }
`;

const StyledIconDrop = styled(Icon)`
  transform: rotate(-90deg);
  ${props =>
    props.expanded &&
    css`
      border-top-color: ${props.theme.colors.primary};
      transform: rotate(90deg);
    `};

  ${props =>
    props.disabled &&
    css`
      border-top-color: ${props.theme.colors.grayLight};
      transform: rotate(0deg);
      &:hover {
        fill: ${props.theme.colors.grayDark};
        cursor: default;
      }
    `};
`;

const StyledButton = styled.button`
  background: ${props => props.theme.colors.light};
  border: 0.0625rem solid ${props => props.theme.colors.grayLight};
  display: flex;
  font-size: ${rem('14px')};
  justify-content: space-between;
  padding: ${rem('13px')} ${rem('10px')};
  width: 100%;
  align-items: center;

  ${props =>
    props.disabled &&
    css`
      background-color: ${props.theme.colors.grayLightest};
      color: ${props.theme.colors.gray};
      cursor: default;
    `};
  ${props =>
    props.error &&
    css`
      border: ${rem('2px')} solid ${props => props.theme.colors.error};
    `};
`;

const StyledError = styled.p`
  color: ${props => props.theme.colors.error};
  font-size: ${rem('12px')};
  line-height: 1rem;
  margin: 0;
  position: absolute;
  bottom: ${rem('-16px')};
  right: 0;
  text-align: right;
  pointer-events: none;
`;

export {
  StyledDropdown,
  StyledButton,
  StyledUl,
  StyledLi,
  StyledLink,
  StyledSpan,
  StyledIconDrop,
  StyledError
};
